import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { Core } from "../helpers/core";
import { Money } from "../helpers/money";
import { AppIcons } from "../constants/app-icons";
import { DOMAIN } from "./domain-constant";

// import { terminology } from "../helpers/terminology";

export default class PayableBillService extends ApiService {
  namespace = "payable-bill";
  relations = "?expand=journalEntries,vendorName,address";
  DOMAIN = DOMAIN.PAYABLE_BILL;
  name = "Payable Bill";
  template = "defaultTemplate";
  Width = 1100;
  icon = "Invoice";
  favicon = "Invoice";
  search = true;
  action = "action";
  singular = this.terminology.bill.singular;
  plural = this.terminology.bill.plural;
  vowel = this.terminology.bill.vowel;
  gemItems = [
    {
      key: "create",
      label: this.t("addAnEntity", { entity: this.singular }),
      icon: AppIcons.PLUS,
    },
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.LIST,
    },
    {
      key: "loader",
      label: this.t("emailEntity", { entity: this.plural }),
      icon: AppIcons.MAIL,
    },
    {
      key: "create",
      label: this.t("generateReport"),
      icon: AppIcons.DOCUMENT,
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: 18,
      icon: AppIcons.DISABLE,
    },
  ];
  columns = [
    {
      header: this.t("number"),
      icon: AppIcons.SHRED,
      field: "number",
    },
    {
      header: this.t("vendor"),
      icon: AppIcons.USER_SILHOUETTE,
      field: "vendorName",
    },
    {
      header: this.t("date"),
      icon: AppIcons.GREEN_CALENDAR,
      field: "date",
      template: (data) => {
        return this.parseDateMoment(data["date"]);
      },
    },
    {
      header: this.t("due"),
      icon: AppIcons.CALENDAR,
      field: "due_date",
      template: (data) => {
        return this.parseDateMoment(data["due_date"]);
      },
    },
    {
      header: this.t("aging"),
      icon: AppIcons.CLOCK,
      field: "date",
      template: (data) => {
        return Core.dateDays(this.parseDateMoment(data["date"]));
      },
    },
    {
      header: this.t("amount"),
      icon: AppIcons.MONEY,
      field: "amount",
      template: (amount) => {
        return Money.format(amount["amount"]);
      },
    },
    {
      header: this.t("balance"),
      icon: AppIcons.MONEY,
      field: "amount",
      template: (amount) => {
        return Money.format(amount["amount"]);
      },
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "Edit an Employee",
      icon: AppIcons.EDIT,
    },
    {
      key: "announce",
      label: "announceThisEntity",
      services: -3,
      icon: AppIcons.BULLETS,
    },
    {
      key: "email",
      label: "emailThisEntity",
      icon: AppIcons.MAIL,
    },
    {
      key: "bookmark",
      label: "bookmarkThisEntity",
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: "inactiveThisEntity",
      icon: AppIcons.LOCK2,
    },
    {
      key: "viewJournal",
      label: "View Journal",
      icon: AppIcons.JOURNAL_VIEW,
    },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: this.t("addAnEntity", { entity: this.singular }),
      icon: AppIcons.LIST,
    },
  ];
  filterItems = [
    {
      name: "Types",
      serviceId: "2",
      value: "2",
      realm: "2",
      selected: true,
      add: "create",
      edit: "listing",
    },
    {
      name: "Categories",
      serviceId: "3",
      value: "3",
      realm: "1",
      selected: false,
      add: "create",
      edit: "listing",
    },
    {
      name: "Folders",
      serviceId: "-2",
      value: "-2",
      realm: "0",
      selected: false,
      add: "create",
      edit: "listing",
    },
  ];
  constructor() {
    super("ap-bills");
  }
}
